const lang = {
    ja: {
        'userRoutes.organizerList': '出展企業一覧',
        'userRoutes.posterList': '閲覧企業チェックリスト',
        'userRoutes.seminarList': 'セミナー一覧',
        'userRoutes.registeredSeminarList': '受講申込みセミナーリスト',
        'userRoutes.contact': '問い合わせ',
        'userRoutes.faq': 'よくあるご質問',
        'userRoutes.liveStream': 'ライブ配信',
        'userRoutes.liveStreamRegister': 'ライブ配信申込みリスト',
        'organizerRoutes.productList': '出展作業',
        'organizerRoutes.seminarList': 'セミナー登録作業',
        'organizerRoutes.adsRegister': '広告登録',
        'organizerRoutes.companyInfo': '企業情報確認',
        'organizerRoutes.contact': '問い合わせ',
        'organizerRoutes.faq': 'よくあるご質問',
        'organizerRoutes.liveStream': 'ライブ配信情報管理',
        'organizerRoutes.settingSellProduct': '商品販売設定',

        // new cr 19/01/2021
        'userRoutes.organizerListNewName': '出展参加者情報一覧',
        'userRoutes.posterListNewName': '見たい企業リスト',
        // new cr 21/01/2021
        'userRoutes.registeredSeminarListNewName': '受講申込みリスト',
        'userRoutes.cart': 'カート',
        // new cr 02/12/2022
        'userRouters.seminar': 'セミナ一覧',
        'userRouters.visitorLogin': '入場者ログイン',
        'userRouters.exhibitorLogin': '出展者ログイン',
        'userRouters.seminarDetail': 'セミナー詳細',
        'userRouters.detailAttended': '受講済みのセミナー詳細',
        'userRouters.shoppingCart': 'ショッピングカート',
        'userRouters.survey': 'アンケート',
        'userRouters.liveStream': 'ライブ配信',
    },
    en: {
        'userRoutes.organizerList': 'Exhibitor list',
        'userRoutes.posterList': 'View exhibitor list',
        'userRoutes.seminarList': 'Seminar list',
        'userRoutes.registeredSeminarList': 'Requested seminar list',
        'userRoutes.contact': 'Contact',
        'userRoutes.faq': 'FAQ',
        'userRoutes.liveStream': 'Live streaming',
        'userRoutes.liveStreamRegister': 'Live streaming application list',

        
        'userRoutes.organizerListNewName': 'Exhibition attendee information list',
        'userRoutes.posterListNewName': 'Favorite company list',
        'userRoutes.registeredSeminarListNewName': 'Attendance application list',
        'userRoutes.cart': 'Cart',
        'userRouters.seminar': 'Seminar list',
        'userRouters.visitorLogin': 'Attendee login',
        'userRouters.exhibitorLogin': 'Exhibitor login',
        'userRouters.seminarDetail': 'Seminar details',
        'userRouters.detailAttended': 'Details of attended seminars',
        'userRouters.shoppingCart': 'Shopping cart',
        'userRouters.survey': 'Questionnaire',
        'userRouters.liveStream': 'Live streaming',
    },
};

export default lang;
